<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <!-- 搜索模块 -->
      <SearchBlock
        leave-list-for-teacher-search
        @getSearchValue="handleGetSearch"
      ></SearchBlock>
    </div>
    <div class="table-title-special-430 flex justify-content_end">
      <!-- 头部搜索框 end  -->
      <div class="ex-btn">
        <Button type="primary" style="margin-right: 16px" @click="handleSetting">批量设置</Button>
        <Button type="primary" @click="handleExport">导出Excel</Button>
      </div>
    </div>
    <div class="table askleave-table">
      <Table
        border
        stripe
        :max-height="tableHeight"
        :columns="leaveColumnsShow"
        :loading="loadingLeaveData"
        :data="leaveData"
        @on-selection-change="onSelectionChange"
      >
        <template slot="schoolName" slot-scope="{ row }">
          <TablePoptip :content="row.schoolName"> </TablePoptip>
        </template>
        <template slot="classroomName" slot-scope="{ row }">
          <TablePoptip :content="row.classroomName"> </TablePoptip>
        </template>
        <template slot="orgName" slot-scope="{ row }">
          <TablePoptip :content="row.orgName"> </TablePoptip>
        </template>

        <template slot="fileIds" slot-scope="{ row }">
          <div>
            <span
              v-if="row.imgList && row.imgList.length > 0"
              class="click-btn-430"
              @click="handleShowImgList(row.imgList)"
            >
              查看图片</span>
            <span v-else>-</span>
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div>
            <!-- 对于已通过请假的，可以设置退款 payType： 1微信  2平安 6工行 isNoDivideAccount 1=挂账子账户(没有账单的) -->
            <!-- isNoDivideAccount  忽略isNoDivideAccount的条件影响（白名单）2023.10.17 -->
            <span
              v-if="
                (row.leaveState === 1 || row.leaveState === 0) &&
                  row.refundSts !== 1 &&
                  portOrg != 3 &&
                  (row.tallySts === 0 || row.tallySts === 2 || row.tallySts === 8)
              "
              class="click-btn-430"
              @click="handleSetRefundType(row)"
            >设置退款</span>
            <!-- 对于审批的，可以进行请假审批 -->
            <span
              v-if="row.leaveState === 0 && portOrg != 3"
              class="click-btn-430"
              @click="handleLeaveSubmit(row)"
            >请假审批</span>
            <span
              v-if="row.refundSts != 1 && portOrg != 3"
              class="click-btn-430"
              style="color: #f56c6c"
              @click="handleToDelete(row)"
            >删除
            </span>
          </div>
        </template>
      </Table>
      <Page
        :total="pageInfo.total"
        show-total
        show-sizer
        show-elevator
        :current="pageInfo.pageNum"
        :page-size-opts="pageSizeOpts"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <ReviewPhoto ref="reviewPhoto" :img-list="selectImgList"></ReviewPhoto>
    <Modal
      v-model="leaveModalShow"
      :width="500"
      title="请假审批"
      :footer-hide="true"
      :mask-closable="!dealLoading"
      @on-visible-change="modalChange"
    >
      <Form
        ref="leaveSubmitForm"
        :model="submitInfo"
        :rules="submitInfoRule"
        :label-width="150"
      >
        <FormItem label="审批结果" prop="leaveState">
          <RadioGroup v-model="submitInfo.leaveState">
            <Radio label="1">通过</Radio>
            <Radio label="2">驳回</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          label="审批说明"
          prop="reviewReason"
        >
          <Input
            v-model="submitInfo.reviewReason"
            maxlength="20"
            show-word-limit
            type="textarea"
            placeholder="请输入审批说明"
          ></Input>
        </FormItem>
        <div class="page-right">
          <Button type="primary" :loading="dealLoading" @click="handleDealLeaveSubmit">确定</Button>
        </div>
      </Form>
    </Modal>
    <BatchSettingForTeacherLeave ref="batchSettingRef" :table-selection="tableSelection" @on-finish="getLeaveTeacherList"></BatchSettingForTeacherLeave>
    <!-- 下载的进度弹窗 -->
    <Modal
      v-model="percentModalShow"
      title="正在导出"
      :mask-closable="false"
      @on-cancel="handleCancelDownLoad"
    >
      <Progress :percent="downLoadPersent" :stroke-width="5"></Progress>
      正在导出表格，请给我一些时间，请不要关闭当前页面！
      <div slot="footer">
        <Button @click="handleCancelDownLoad">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
import SearchBlock from '../assets/components/SearchBlock.vue';
import ReviewPhoto from '@c/ReviewPhoto.vue';
import BatchSettingForTeacherLeave from './components/BatchSettingForTeacherLeave.vue';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { leaveTypeEnumList, leaveStateEnumList, refundStsEnumList, isRetMoneyEnumList, changeDictionaries } from '@/utils/dictionary.js';
import eduCenter from '@/request/eduCenter/index.js';
import { mapState } from 'vuex';
import axios from 'axios';
import { downLoadByBlob } from '@/pages/assetsModules/common.js';
export default {
  components: {
    SearchBlock,
    ReviewPhoto,
    BatchSettingForTeacherLeave
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      submitInfo: {
        leaveState: '', // 1 通过 2驳回
        reviewReason: '' // 审核原因
      },
      leaveModalShow: false,
      leaveColumns: [
        key('请假编号', 'leaveId', tableColumnsWidth.type4, { fixed: 'left' }),
        slot('学校', 'schoolName', tableColumnsWidth.type3, { fixed: 'left' }),
        key('教师姓名', 'teacherName', tableColumnsWidth.type2, { fixed: 'left' }),
        key('学期', 'yearTermName', tableColumnsWidth.type4),
        slot('课程班级名称', 'classroomName', tableColumnsWidth.type6),
        key('上课时间', 'timeDesc', tableColumnsWidth.type6, {
          render: (h, params) => {
            return renderFn(h, params);
          }
        }),
        slot('提供方', 'orgName', tableColumnsWidth.type6),
        key('请假时间（时间/节次）', 'classTime', tableColumnsWidth.type5),
        key('请假单创建时间', 'leaveTime', tableColumnsWidth.type4),
        key('请假类型', 'leaveType', tableColumnsWidth.type2, {
          render: (h, params) => {
            return h('div', [
              changeDictionaries(leaveTypeEnumList)[params.row.leaveType]
            ]);
          },
          align: 'center'
        }),
        key('请假事由', 'leaveDescribe', tableColumnsWidth.type9, {
          render: (h, params) => {
            return renderFn(h, params);
          },
          align: 'center'
        }),
        slot('图片', 'fileIds', tableColumnsWidth.type2, {
          align: 'center'
        }),
        key('请假状态', 'leaveState', tableColumnsWidth.type2, {
          render: (h, params) => {
            return h('div', {
              style: {
                'color': this.leaveStateColor[params.row.leaveState] || '#515a6e'
              }
            }, [
              changeDictionaries(leaveStateEnumList)[params.row.leaveState] || '-'
            ]);
          },
          align: 'center'
        }),
        slot('操作', 'action', tableColumnsWidth.type6, { fixed: 'right' })
      ],
      leaveStateColor: [
        '#488ffa', // 审批中
        'green', // 已通过
        'red', // 已驳回
        '#333' // 已撤销
      ],
      loadingLeaveData: false,
      leaveData: [],
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      }, // 请假列表分页信息
      pageSizeOpts: [10, 20, 50, 100],
      searchData: {},
      selectImgList: [],
      selectRow: {},
      leaveIds: [],
      dealLoading: false,
      tableSelection: [],
      percentModalShow: false,
      downLoadPersent: 0,
      percentInterVal: null,
      source: null
    };
  },
  computed: {
    ...mapState(['portOrg']),
    submitInfoRule() {
      return {
        leaveState: [
          { required: true, message: '请选择审批结果', trigger: 'change' }
        ],
        reviewReason: [
          { required: +this.submitInfo.leaveState === 2, message: '请输入审批说明' }
        ]
      };
    },
    leaveColumnsShow() {
      if (+this.portOrg === 0 || +this.portOrg === 2) {
        const leaveIdList = [{
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        }];
        return leaveIdList.concat(this.leaveColumns);
      }

      return this.leaveColumns;
    }
  },
  methods: {
    // 获取要搜索的入参
    handleGetSearch(searchValue) {
      this.pageInfo.pageNum = 1;
      this.searchData = searchValue;
      console.log(this.searchData, '请求的---');
      this.getLeaveTeacherList();
    },
    // 重置搜索
    initSearch(pageNum = 1) {
      this.pageInfo.pageNum = pageNum;
      this.getLeaveTeacherList();
    },
    // 获取学生列表
    async getLeaveTeacherList() {
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      const { schoolId, ...otherSearchData } = this.searchData;

      const paramsData = Object.assign({}, otherSearchData, params, { schoolId: schoolId === -1 ? null : schoolId });
      try {
        this.loadingLeaveData = true;
        const res = await eduCenter.getTeacherLeavePageApi(paramsData);
        this.tableSelection = [];
        if (res.status === 200 && res.message.list) {
          this.leaveData = res.message.list.map(item => {
            item.reviewReason = item.reviewReason || '-';
            item.imgList = item.fileIds ? JSON.parse(item.fileIds) : [];
            return item;
          });
          this.pageInfo.total = Number(res.message.total);
        } else {
          this.leaveData = [];
          this.pageInfo.total = 0;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingLeaveData = false;
      }
    },
    // 点击打开照片
    handleShowImgList(imglist) {
      this.selectImgList = imglist;
      this.$nextTick(() => {
        this.$refs.reviewPhoto.open();
      });
    },
    // 点击展示请假审批弹窗
    handleLeaveSubmit(row) {
      this.selectRow = row;
      this.leaveIds = [row.leaveId];
      this.$nextTick(() => {
        this.leaveModalShow = true;
      });
    },
    // 处理请假审批
    handleDealLeaveSubmit() {
      this.$refs.leaveSubmitForm.validate((valid) => {
        if (valid) {
          this.dealLeave();
        }
      });
    },
    // 对教师发起的请假审批
    async dealLeave() {
      const params = {
        leaveIds: this.leaveIds,
        leaveState: this.submitInfo.leaveState,
        reviewReason: this.submitInfo.reviewReason
      };
      this.dealLoading = true;
      try {
        const res = await eduCenter.postAatchTeacherLeaveAuditApi(params);
        if (res.status === 200) {
          this.$Message.success('已处理！');
          this.initSearch(this.pageInfo.pageNum);
          this.leaveModalShow = false;
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.dealLoading = false;
      }
    },
    handleToDelete(row) {
      this.$Modal.confirm({
        title: '温馨提示',
        content: '<p>是否确认删除？</p>',
        loading: true,
        onOk: () => {
          this.deleteLeave({ leaveId: row.leaveId });
        },
        onCancel: () => {

        }
      });
    },
    // 删除请假单
    async deleteLeave(data) {
      const res = await eduCenter.deleteTeacherLeaveApi(data);
      if (res.status === 200) {
        this.pageInfo.pageNum = 1;
        this.$Message.success('删除成功');
        this.getLeaveTeacherList();
        this.$Modal.remove();
      }
    },
    modalChange(status) {
      console.log(this.submitInfo, '拿到的数据0--2321');
      console.log(status, '拿到的---');
      if (!status) {
        this.$nextTick(() => {
          this.$refs.leaveSubmitForm.resetFields();
        });
      }
    },
    // 表格选择事件
    onSelectionChange(selection) {
      this.tableSelection = selection;
    },
    handleSetting() {
      if (this.tableSelection.length == 0) {
        this.$Message.warning('请先勾选要设置的数据');
        return null;
      }
      this.$refs.batchSettingRef.handleShow();
    },
    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getLeaveTeacherList();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getLeaveTeacherList();
    },

    handleExport() {
      this.handleExSubmit();
    },
    // 取消导出
    handleCancelDownLoad() {
      this.percentModalShow = false;
      if (this.source) {
        this.source.cancel('取消导出'); // 这里传递的什么字符串，在上面的rej.message值就是什么
        // this.uploadPersent = 0;
        // this.canUploadFile = true;
        // this.modalShow = false;
        // this.uploadType === '';
      }
    },
    // 导出进度条模态框提示
    percentShowFun() {
      this.downLoadPersent += 20;
      if (this.downLoadPersent >= 80) {
        clearInterval(this.percentInterVal);
      }
    },
    percentShow() {
      this.downLoadPersent = 0;
      this.percentInterVal = setInterval(this.percentShowFun, 500);
    },
    // 导出-确定
    async handleExSubmit() {
      const params = {
        pageNum: 1,
        pageSize: this.pageInfo.total
      };
      const paramsData = Object.assign({}, this.searchData, params);
      this.percentModalShow = true;
      this.percentShow();
      const CancelToken = axios.CancelToken;
      this.source = CancelToken.source();
      const onDownloadProgress = progressEvent => {
        if (progressEvent.lengthComputable) {
          const val = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);
          this.downLoadPersent = parseInt(val);
        }
      };
      const res = await eduCenter.getTeacherLeaveExportApi(
        paramsData,
        this.source.token,
        onDownloadProgress
      );
      if (res) {
        const reader = new FileReader();
        let resData = null;
        reader.readAsText(res.data, 'utf-8');
        reader.onload = () => {
          if (res.data.type === 'application/vnd.ms-excel') {
            this.$Message.success('导出成功');
            clearInterval(this.percentInterVal);
            this.downLoadPersent = 100;
            setTimeout(() => {
              this.percentModalShow = false;
            }, 500);
            downLoadByBlob(res);
          } else {
            resData = JSON.parse(reader.result);
            clearInterval(this.percentInterVal);
            this.downLoadPersent = 100;
            setTimeout(() => {
              this.percentModalShow = false;
            }, 500);
            this.$Message.error(resData.error);
          }
        };
      } else {
        this.percentModalShow = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.page-right {
  text-align: right;
  margin-top: 16px;
}
</style>
